module.exports = __webpack_public_path__ + "public/img/todayUp.86e8f9e6.png";